import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './UploadCard.css';

const IMG_BASE = process.env.REACT_APP_API_URL?.replace('/api', '') ?? '';

function getUploaderPictureUrl(uploaderPicture) {
  if (!uploaderPicture) return null;
  if (/^https?:\/\//i.test(uploaderPicture)) return uploaderPicture;
  return `${IMG_BASE}/${String(uploaderPicture).replace(/^\/+/, '')}`;
}

function timeAgo(dateStr) {
  const diff = Date.now() - new Date(dateStr.replace(' ', 'T') + 'Z').getTime();
  const mins = Math.floor(diff / 60000);
  const hours = Math.floor(diff / 3600000);
  const days = Math.floor(diff / 86400000);
  const weeks = Math.floor(days / 7);
  const months = Math.floor(days / 30);
  const years = Math.floor(days / 365);

  if (mins < 60) return `${mins}m ago`;
  if (hours < 24) return `${hours}h ago`;
  if (days < 7) return `${days}d ago`;
  if (weeks < 5) return `${weeks}w ago`;
  if (months < 12) return `${months}mo ago`;
  return `${years}yr ago`;
}

function UploadCard({ id, title, author, uploadedBy, uploaderPicture, createdAt }) {
  const navigate = useNavigate();
  const [avatarFailed, setAvatarFailed] = useState(false);
  const avatarUrl = avatarFailed ? null : getUploaderPictureUrl(uploaderPicture);
  const uploaderInitial = String(uploadedBy || 'R').trim().charAt(0).toUpperCase() || 'R';

  return (
    <div
      className="upload-card-wrapper p-3 d-flex align-items-center gap-4 rounded-2"
      onClick={() => navigate(`/epub/${id}`)}
      role="button"
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          navigate(`/epub/${id}`);
        }
      }}
    >

      <div className="uploads-left d-flex align-items-center justify-content-center">
        <span className="uploads-left-letter">
          {title?.charAt(0).toUpperCase()}
        </span>
      </div>

      <div className="uploads-middle d-flex flex-column gap-1">
        <h5 className="mb-0">{title}</h5>
        <p className="uploads-author mb-2">{author}</p>

        <div className="d-flex align-items-center gap-2 pt-2">
          <div className="uploader-avatar">
            {avatarUrl ? (
              <img src={avatarUrl} alt="" onError={() => setAvatarFailed(true)} />
            ) : (
              <span className="uploader-avatar__fallback">{uploaderInitial}</span>
            )}
          </div>
          <p className="uploads-uploader-text mb-0">
            Uploaded by <strong>{uploadedBy}</strong>
          </p>
        </div>
      </div>

      <div className="uploads-right ms-auto">
        {createdAt && (
          <div className="d-inline-block p-1">
            <span className="uploads-timestamp">{timeAgo(createdAt)}</span>
          </div>
        )}
      </div>

    </div>
  );
}

export default UploadCard;
